// extracted by mini-css-extract-plugin
export default {"rating":"oW-z","numberOfStars":"pW-z","count":"qW-z","barGraphSpacing":"rW-z","barGraph":"sW-z"};